import MensagensClienteView from '@/views/mensagens-cliente/MensagensClienteView.vue'
import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import DashboardView from '@/views/dashboard/DashboardView.vue'
import ListaAvaliacaoView from '@/views/avaliacao/ListaAvaliacaoView.vue'
import PosVendaAvaliacaoGooglesView from '@/views/pos-venda-avaliacao/PosVendaAvaliacaoGooglesView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: 'mensagens-cliente',
      name: 'mensagens-cliente',
      component: MensagensClienteView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'pos-venda-avaliacao-google',
      name: 'pos-venda-avaliacao-google',
      component: PosVendaAvaliacaoGooglesView,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: 'avaliacao',
      name: 'avaliacao',
      component: ListaAvaliacaoView,
      meta: {
        requiresAuth: true,
      },
    },
  ],
}
